import axios from 'axios'

export default class Alertas {
  constructor(tokenBearer, url) {
    this.url = `${url}/api`
    this.tokenBearer = tokenBearer
  }
  async getAlertas(id) {
    return await axios({
      method: 'get',
      url: `${this.url}/alertas/${id}`,
      headers: { Authorization: this.tokenBearer }
    })
  }

  async consultarAlertas(){
    return await axios({
      method: 'get',
      url: `${this.url}/alertas`,
      headers: { Authorization: this.tokenBearer }
    })
  }

  async marcarAlertaComoResolvido(idUnimed, versaoUnimed, tipoAlerta){
    return await axios({
      method: 'delete',
      url: `${this.url}/alertas`,
      headers: { Authorization: this.tokenBearer },
      data: {
        tipoAlerta: tipoAlerta,
        idUnimed: idUnimed,
        versaoUnimed: versaoUnimed
      }
    })
  }


}
